import React from 'react';
import { motion } from 'framer-motion';
interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  dark?: boolean;
}
export const SectionHeading: React.FC<SectionHeadingProps> = ({
  title,
  subtitle,
  dark = false
}) => {
  return <div className="text-center mb-16" data-id="element-293">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-294">
        <div className="flex items-center justify-center gap-4 mb-4" data-id="element-295">
          <span className={`h-px w-12 ${dark ? 'bg-gold-500/30' : 'bg-gold-500/50'}`} data-id="element-296"></span>
          <span className="text-gold-500 text-xl" data-id="element-297">✦</span>
          <span className={`h-px w-12 ${dark ? 'bg-gold-500/30' : 'bg-gold-500/50'}`} data-id="element-298"></span>
        </div>
        <h2 className={`text-4xl md:text-5xl font-bold mb-6 text-balance ${dark ? 'text-cream' : 'text-navy'}`} data-id="element-299">
          {title}
        </h2>
        {subtitle && <p className={`text-lg max-w-2xl mx-auto ${dark ? 'text-cream-200' : 'text-navy/80'}`} data-id="element-300">
            {subtitle}
          </p>}
      </motion.div>
    </div>;
};